<template>
  <v-menu
    v-if="isAccesToCriteriaTemplate"
    left
    offset-x
    offset-y>
    <template #activator="{ on }">
      <div
        v-on="on"
        @click.prevent="">
        <sButton
          data-qa="btn-action-lest-menu"
          icon="menu"
          small
          type="text"/>
      </div>
    </template>
    <div
      class="menu">
      <SaveCriteriaAsTemplate
        :card="card"
        edit
        :next-func="updateCard"
        :tender="tender"/>
      <MenuItem
        data-qa="item-delete"
        icon="delete"
        :label="$t('Tenders.RemoveFromTemplates').toUpperCase()"
        small
        @click="deleteItem"/>
    </div>
  </v-menu>
</template>
<script>
import MenuItem from 'components/common/MenuItem.vue'
import SaveCriteriaAsTemplate from 'components/tenders/critetia/SaveCriteriaAsTemplate.vue'
/* eslint-disable vue/no-mutating-props */

import { tenderMixin } from 'mixins'
import godModeMixin from 'mixins/godModeMixin'
import SmarttenderApi from '@/api/smarttenderApi'
const api = new SmarttenderApi()

export default {
  name: 'criteriaTemplateMenu',
  mixins: [tenderMixin, godModeMixin],
  methods: {
    deleteItem() {
      this.$Modal.confirm({
        title: this.$t('Tenders.SureToDeleteCriteriaTemplate', {name: this.card?.name}),
        closable: true,
        okText: this.$t('Purchasing.Remove'),
        loading: true,
        cancelText: this.$t('Common.Cancel'),
        onOk: async () => {
          await api.deleteCriteriaCardTemplate(this.card?.templateId)
          this.$emit('deleteCard', this.card?.templateId )
          this.$Modal.remove()
        },
        width: 736
      })
    },
    updateCard(options) {
      if ( !options ) { return }
      let { name, category, biddingType, isDefault, isLocked } = options
      this.card.name = name
      this.card.category = category?.title
      this.card.biddingType = biddingType?.titleRu
      this.card.classificationCode = category?.classificationCode
      this.card.biddingTypeId = biddingType?.biddingTypeId
      this.card.isDefault = isDefault
      this.card.isDefault = isDefault
      this.card.isLocked = isLocked ? 'LOCKED' : 'UNLOCKED'
      this.$emit('updateCard', this.card?.templateId )
    }
  },
  components: {
    MenuItem,
    SaveCriteriaAsTemplate
  },
  props: {
    card: Object,
    tender: {
      type: Object
    }
  },
}
</script>
